import { firstValueFrom } from 'rxjs'

import { Component, Inject, OnInit } from '@angular/core'
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog'
import { FormControl } from '@angular/forms'

import { ProductPriceFragment, SimpleProductFragment } from '@app-graphql/schema'
import { CheckoutService, ProductService } from '@app-services'
import { ExposeEnums } from '@app-helpers'
import { LocalizationService } from '@app-domains/localization/service/localization.service'

@Component({
    selector: 'app-add-to-cart-modal',
    templateUrl: './add-to-cart-modal.component.html',
    styleUrls: ['./add-to-cart-modal.component.scss'],
})
export class AddToCartModalComponent extends ExposeEnums implements OnInit {

    public product: SimpleProductFragment
    public debtorPrice: ProductPriceFragment
    public loading: boolean
    public submitting: boolean

    public amountToOrder = new FormControl('1', {
        nonNullable: true,
    })

    constructor(
        public readonly dialogRef: DialogRef,
        private readonly checkoutService: CheckoutService,
        public readonly localizationService: LocalizationService,
        private readonly productService: ProductService,
        @Inject(DIALOG_DATA) private readonly data: SimpleProductFragment,
    ) {
        super()
    }

    public ngOnInit(): void {
        this.loading = true
        this.product = this.data

        void this.doAsyncInit()
    }

    private async doAsyncInit(): Promise<void> {
        const result = await firstValueFrom(this.productService.getProductsOrderProperties({
            eans: [this.data.ean],
        }))

        if (result.data.productsByEan[0].price) {
            this.debtorPrice = result.data.productsByEan[0].price
        }

        this.loading = false
    }

    public closeDialog(): void {
        this.dialogRef.close()
    }

    public async orderAgain(): Promise<void> {
        this.submitting = true

        await this.checkoutService.addToShoppingCart([{
            ean: this.product.ean,
            quantity: parseInt(this.amountToOrder.value),
        }])

        this.submitting = false

        this.closeDialog()
    }
}
